/**
 * Picks v2 or v1 of the Featured Quick Taps page based on the
 * redesign flag. Same pattern as QuickTapsPageSwitch /
 * CategoriesPageSwitch / etc.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import QuickTapsFeaturedPage   from './QuickTapsFeaturedPage';
import QuickTapsFeaturedPageV2 from './QuickTapsFeaturedPageV2';

export default function QuickTapsFeaturedPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? QuickTapsFeaturedPageV2 : QuickTapsFeaturedPage;
  return <Component {...props} />;
}
